import React, { createContext, useEffect, useContext, useState } from 'react';
import get from 'lodash/get';

import { FormContext } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';

import { DESIGNER, OUTSOURCE_STUDIO } from './constants';

export const DesignerAndOutsourceStudioContext = createContext({});

export const DesignerAndOutsourceStudioProvider = ({ children, path }) => {
  const { values: valuesRoot } = useContext(FormContext);

  const values = get(valuesRoot, path, valuesRoot);

  const { designer: designerContext, designerType: designerTypeContext } =
    useContext(DesignerAndOutsourceStudioContext);

  const [childComponent, openChildComponent] = useChildComponent();
  const [designerType, setDesignerType] = useState(() => designerTypeContext);
  const [designer, setDesigner] = useState(() => designerContext);

  useEffect(() => {
    setDesignerType(designerTypeContext);
  }, [designerTypeContext]);

  useEffect(() => {
    setDesigner(designerContext);
  }, [designerContext]);

  useEffect(() => {
    if (values[CREATIVE.DESIGNER] && designerType !== DESIGNER) {
      setDesignerType(DESIGNER);
    } else if (
      values[CREATIVE.OUTSOURCE_STUDIO_ID] &&
      designerType !== OUTSOURCE_STUDIO
    ) {
      setDesignerType(OUTSOURCE_STUDIO);
    } else if (!designerType) {
      setDesignerType(DESIGNER);
    }
  }, [values[CREATIVE.OUTSOURCE_STUDIO_ID], values[CREATIVE.DESIGNER]]);

  return (
    <DesignerAndOutsourceStudioContext.Provider
      value={{
        setDesignerType,
        setDesigner,
        designerType,
        designer,
        path,
        openChildComponent,
      }}
    >
      {children}
      {childComponent}
    </DesignerAndOutsourceStudioContext.Provider>
  );
};
